import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Contemporary_Period_-_Modern_Conflicts_e.g._Middle_East_Ukraine.png';

function HistoryPageModernConflicts() {
  return (
    <TopicPage
      topicKey="Modern Conflicts (e.g., Middle East, Ukraine)"
      title="History: Modern Conflicts"
      backgroundImage={bg}
      startRoute="/History-Modern-Conflicts-Go"
      scrollLabels={[
        "Middle East Wars",
        "Ukraine Conflict",
        "Global Peacekeeping"
      ]}
      backRoute="/history-contemporary"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageModernConflicts;
